import { render, staticRenderFns } from "./CommunicationLed.vue?vue&type=template&id=ade6237a&"
import script from "./CommunicationLed.vue?vue&type=script&lang=js&"
export * from "./CommunicationLed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports